import { validateSSN } from '@gjensidige/se-helpers';

import { ageResolver } from '../utils/CalculationHelper';

/*
 * Keeping validations in a separate file to easier move them to sweden-core validations later on.
 */

export const MIN_AGE = 18;
const MIN_YEAR_PREFIX = 19;
const ZIP_CODE_LENGTH = 5;
const MAX_ADDR_LENGTH = 40;
const MIN_ADDR_LENGTH = 3;
const MAX_PROPERTY_ID_LENGTH = 50;
const MIN_PROPERTY_ID_LENGTH = 3;

export const validatePropertyName = (propertyId: any) => {
  if (
    propertyId.length > MAX_PROPERTY_ID_LENGTH &&
    propertyId.length <= MIN_PROPERTY_ID_LENGTH
  ) {
    return false;
  }
  const propertyNameNoWhitespace = propertyId.replace(/\s/g, '');
  const regex = /^[a-zA-ZåäöÅÄÖ.,-]+\d+([:,.]?[a-zA-ZåäöÅÄÖ.,-:\d]+)?$/u;
  return regex.test(propertyNameNoWhitespace);
};

export const validateMunicipality = (Municipality: any) =>
  Municipality.length <= MAX_ADDR_LENGTH &&
  Municipality.length >= MIN_ADDR_LENGTH;

export const validateAddress = (address: any) =>
  address.length <= MAX_ADDR_LENGTH && address.length >= MIN_ADDR_LENGTH;

export const validateZipCode = (value: any) => value.length === ZIP_CODE_LENGTH;

export const validateCprAndAge = (options: any, inputValue: any) => {
  if (
    (inputValue.length !== 10 && inputValue.length !== 12) ||
    (inputValue.length === 12 &&
      Number(inputValue.slice(0, 2)) < MIN_YEAR_PREFIX) ||
    !validateSSN(inputValue)
  ) {
    return false;
  } else {
    if (ageResolver(inputValue) < options.age) {
      return false;
    } else return true;
  }
};

export const isVolontaryPhoneValid = (phoneNr: string) => {
  if (!phoneNr) {
    return true;
  }

  if (!/^[0-9]*$/.test(phoneNr)) {
    return false;
  }

  if (phoneNr.length < 9 || phoneNr.length > 10) {
    return false;
  }

  return true;
};
